import { useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AddActionDialogType } from '@pages/EntityCreateOrEdit'

import { useFetchDictionariesByCategoryCodeQuery } from '@redux/api'

import { CATEGORIES, TIMELINE_ACTION_COLUMNS } from '@constants'
import { ActionRow, GETShareColumn, ModalType } from '@types'

import { AddMenuPointForm } from '../components/AddMenuPointDialog'

type UseMenuPointActionsType = {
  actions?: ActionRow[]
  setValue: UseFormSetValue<AddMenuPointForm>
  objectCode: string
}

export const useMenuPointActionsHandlers = (props: UseMenuPointActionsType) => {
  const { actions = [], setValue, objectCode } = props

  const { t } = useTranslation()

  const { data: bindingValuesAction } = useFetchDictionariesByCategoryCodeQuery(
    CATEGORIES.BINDING_CONTEXT_MENU_POINT_ACTION
  )

  const [showAddActionDialog, setShowAddActionDialog] = useState(false)
  const [addActionDialogData, setAddActionDialogData] = useState<
    | Omit<
        AddActionDialogType,
        'createAction' | 'editAction' | 'showDialog' | 'onCloseModal' | 'actionEventsCategoryCode'
      >
    | undefined
  >(undefined)

  const handleCloseAddActionDialog = (isDirty?: boolean) => {
    if (!isDirty) {
      setShowAddActionDialog(false)
      setAddActionDialogData(undefined)

      return
    }

    if (confirm(t('notifications.leave'))) {
      setShowAddActionDialog(false)
      setAddActionDialogData(undefined)
    }
  }

  const handleOpenAddActionDialog = (modalType: ModalType, id?: string | number) => {
    const actionData = actions?.find(item => item.code === id)

    setShowAddActionDialog(true)
    setAddActionDialogData({
      modalType,
      bindingValuesAction,
      objectCode,
      currentRow: actionData as GETShareColumn,
      actionTable: {
        columns: TIMELINE_ACTION_COLUMNS,
        rows: actions || [],
      },
      columns: [],
    })
  }

  const handleChangeAction = (data: ActionRow) => {
    const columnIndex = actions?.findIndex(item => item.id === data.id)

    if (columnIndex && columnIndex < 0) {
      setValue('actions', actions.concat(data), {
        shouldDirty: true,
      })

      return
    }

    actions[columnIndex] = data
    setValue('actions', actions, {
      shouldDirty: true,
    })
  }

  const handleDeleteAction = (id: string | number) => {
    setValue(
      'actions',
      actions.filter(item => item.id !== id),
      {
        shouldDirty: true,
      }
    )
  }

  return {
    data: {},
    state: {
      showAddActionDialog,
      addActionDialogData,
    },
    handlers: {
      handleOpenAddActionDialog,
      handleCloseAddActionDialog,
      handleChangeAction,
      handleDeleteAction,
    },
  }
}
